// react
import { useCallback, useRef } from 'react';

// mui
import { Box, Divider, Paper, Stack, Typography } from '@mui/material';

export interface EmailPreviewProps {
  recipientEmail: string;
  subject: string;
  emailHtml: string;
}

export const EmailPreview = ({
  recipientEmail,
  subject,
  emailHtml,
}: EmailPreviewProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const adjustIframeHeight = useCallback(() => {
    const iframe = iframeRef.current;
    if (!iframe?.contentDocument?.body) return;
    iframe.style.height = iframe.contentDocument.body.scrollHeight + 'px';
  }, []);

  return (
    <Paper elevation={2}>
      <Stack
        spacing={1}
        sx={{
          padding: 2,
        }}
      >
        <Typography
          variant='body2'
          sx={{
            color: 'text.secondary',
          }}
        >
          To: {recipientEmail}
        </Typography>
        <Typography
          variant='body2'
          sx={{
            color: 'text.secondary',
          }}
        >
          Subject: {subject}
        </Typography>
      </Stack>
      <Divider />
      <Box sx={{ overflow: 'hidden' }}>
        <iframe
          ref={iframeRef}
          srcDoc={emailHtml}
          onLoad={adjustIframeHeight}
          title='Email preview'
          scrolling='no'
          style={{
            width: '100%',
            border: 'none',
            display: 'block',
          }}
        />
      </Box>
    </Paper>
  );
};

EmailPreview.displayName = 'EmailPreview';
export default EmailPreview;
